<!--
  Sub-modale "Conferma documenti" — secondo step wizard picking (v2.11.0 J.4.b).
  Diakonix native modal pattern (z-index 2100).
-->
@if (openedDoc) {
  <div class="cd-backdrop" (click)="close()">
    <div
      class="cd-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cd-title"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <header class="cd-header">
        <div class="cd-title-block">
          <h2 id="cd-title">📄 Conferma documenti</h2>
          @if (order?.or_order_number) {
            <p class="cd-subtitle">
              Ordine n° <strong>{{ order.or_order_number }}</strong>
            </p>
          }
        </div>
        <button
          type="button"
          class="cd-close"
          aria-label="Chiudi"
          (click)="close()"
        >
          <i class="bx bx-x"></i>
        </button>
      </header>

      <!-- Body -->
      <div class="cd-body">
        @if (loading) {
          <div class="cd-loading">
            <i class="bx bx-loader-alt bx-spin"></i>
            Caricamento documenti...
          </div>
        } @else {
          <!-- DDT + EG actions -->
          <section class="cd-section">
            <h3 class="cd-section-title">
              <i class="bx bx-printer"></i> Stampa DDT / EG
            </h3>
            <div class="cd-print-actions">
              <button
                type="button"
                class="cd-btn cd-btn--print"
                (click)="printDDTStamp()"
              >
                <i class="bx bx-printer"></i>
                Stampa DDT
              </button>

              @if (linkToDDT) {
                <a
                  [href]="linkToDDT"
                  target="_blank"
                  rel="noopener"
                  class="cd-link-badge"
                >
                  <i class="bx bx-file"></i>
                  DDT pronto
                </a>
              }

              <button
                type="button"
                class="cd-btn cd-btn--print cd-btn--print-eg"
                [disabled]="!isLinkToEG"
                (click)="printELG()"
              >
                <i class="bx bx-printer"></i>
                Stampa EG
              </button>

              @if (!isLinkToEG) {
                <span class="cd-badge cd-badge--warn">
                  <i class="bx bx-info-circle"></i>
                  Elaborato non disponibile sul CRM
                </span>
              }
            </div>
          </section>

          <!-- Documents list -->
          <section class="cd-section">
            <h3 class="cd-section-title">
              <i class="bx bx-list-check"></i>
              Documenti selezionabili
              <span class="cd-count">{{ documents?.length || 0 }}</span>
            </h3>

            @if (!documents?.length) {
              <div class="cd-empty">
                <p>Nessun documento disponibile per questo ordine.</p>
              </div>
            } @else {
              <div class="cd-docs-list">
                @for (doc of documents; track doc.td_document; let i = $index) {
                  <label
                    class="cd-doc"
                    [class.cd-doc--checked]="doc.checked"
                  >
                    <input
                      type="checkbox"
                      [checked]="doc.checked"
                      (change)="checkDocument(i)"
                    />
                    <span class="cd-doc-checkmark"></span>
                    <span class="cd-doc-name">{{ doc.td_document }}</span>
                  </label>
                }
              </div>
            }

            @if (allDocumentsChecked()) {
              <span class="cd-badge cd-badge--ok cd-badge--inline">
                <i class="bx bx-check-circle"></i>
                Tutti i documenti selezionati
              </span>
            }
          </section>
        }
      </div>

      <!-- Footer -->
      <footer class="cd-footer">
        <button
          type="button"
          class="cd-btn cd-btn--all"
          (click)="printAllDocuments()"
        >
          <i class="bx bx-printer"></i>
          Stampa tutto
        </button>
        <button
          type="button"
          class="cd-btn cd-btn--save"
          (click)="saveStep('documents')"
        >
          <i class="bx bx-check-circle"></i>
          Salva
        </button>
      </footer>
    </div>
  </div>
}
